module.exports = __webpack_public_path__ + "img/ad2_img.0cd323ae.png";